export default "__VITE_ASSET__81141394__"